import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ServicesService } from '~shared/servicios/services.service';
import { InicioNComponent } from '../inicio-n.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends InicioNComponent implements OnInit {

  Beneficios: any[] = [
    {
      id: 1,
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Seg-datos-new.png',
      titulo: 'Seguridad de datos',
      parrafo: 'Contamos con tecnología robusta que garantiza la seguridad de tu información'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Soporte-new.png',
      titulo: 'Soporte',
      parrafo: 'Con Triidy podras contar con nuestro soporte de atención al cliente'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Comunidad-new.png',
      titulo: 'Comunidad',
      parrafo: 'Forma parte de la comunidad de comercios electrónicos más grande de Colombia'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/ProdGana-new.png',
      titulo: 'Productos ganadores',
      parrafo: 'Accede a los catálogos de artículos en tendencia de ventas por internet'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Pagos-new.png',
      titulo: 'Pagos contra entrega',
      parrafo: 'Contamos con este método de pago para incrementar tus ventas hasta un 150%'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Boost-new.png',
      titulo: 'Triidy Boost',
      parrafo: 'Adelantamos el dinero de tus ventas para que no pares de crecer'
    }
  ]

  funciona: any[] = [
    {
      id: 1,
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/secc7-one-new.png',
      titulo: 'Registrate',
      texto: 'Ingresa a Triidy.com y registrate'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/secc7-two-new.png',
      titulo: 'Agrega un producto',
      texto: 'Crea tu propio producto o agrega uno Dropshipping'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/secc7-three-new.png',
      titulo: 'Empieza a vender',
      texto: 'Vende por el canal que quieras y factura con Triidy'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/secc7-four-one.png',
      titulo: 'Genera ganancias',
      texto: 'Vende tus productos y empieza a ganar dinero con Triidy'
    }
  ]

  constructor(public router: Router, public service: ServicesService, public cookieSvc: CookieService, public snackBar: MatSnackBar) {
    super(router, service, cookieSvc, snackBar);
  }

  ngOnInit(): void {
  }

  clickM() {
    this.service.emitChange(true);
  }

  descargaWin(): void {
    window.open('https://triidyftp.s3.us-east-2.amazonaws.com/Triidy.rar', '_blank');
  }

  descargaAnd(): void {
    window.open('https://play.google.com/store/apps/details?id=app.avalon.triidy', '_blank');
  }

}
